import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/banner_thick.svg'
import _imports_1 from '../assets/powered-by-strava.svg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container h-100" }
const _hoisted_3 = { class: "row h-100 justify-content-center py-2" }
const _hoisted_4 = { class: "col-4 align-self-center" }
const _hoisted_5 = { class: "logo-footer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "py-2",
  src: _imports_0
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://strava.com/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "pt-2",
    src: _imports_1
  })
], -1)
const _hoisted_8 = { class: "col text-end align-self-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }),
  /*#__PURE__*/_createElementVNode("a", {
    class: "footer-mail",
    href: "mailto:mail@klatrekongen.no"
  }, "mail@klatrekongen.no")
], -1)
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Personvernerklæring")
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col\"> Developed by <a href=\"https://www.linkedin.com/in/livselleunderhaug/\" target=\"_blank\">Liv Selle Underhaug</a></div></div><div class=\"row\"><div class=\"col\"> © 2022 <a href=\"https://www.linkedin.com/company/switchbacknorway\" target=\"_blank\">Switchback Norway AS</a></div></div>", 2)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"col-1 align-self-end pb-3 text-end icon-size\"><ul class=\"list-unstyled m-0\"><li><a href=\"https://www.strava.com/clubs/980836\" target=\"_blank\"><i class=\"fa-brands fa-strava\"></i></a></li><li><a href=\"https://www.instagram.com/klatrekongen/\" target=\"_blank\"><i class=\"fa-brands fa-instagram\"></i></a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, { to: "/privacy" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_13
        ]),
        _hoisted_15
      ])
    ])
  ]))
}